import { render, staticRenderFns } from "./Kerkschip.vue?vue&type=template&id=578de103&"
import script from "./Kerkschip.vue?vue&type=script&lang=ts&"
export * from "./Kerkschip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports